import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";

export const getJournalEntries = createAsyncThunk(
  "journal/getJournalEntries",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { date } = formInfo;
      const res = await api.get(`journal/${date}`);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const postJournalEntry = createAsyncThunk(
  "journal/postJournalEntry",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { date, entry } = formInfo;
      const res = await api.post(`journal/${date}`, { entry });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const clearJournalEntry = createAsyncThunk(
  "journal/clearJournalEntry",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { date } = formInfo;
      const res = await api.delete(`journal/${date}`);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getTradeReview = createAsyncThunk(
  "journal/getTradeReview",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { trade_id } = formInfo;
      const res = await api.get(`trade/${trade_id}/review`);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const createTradeReview = createAsyncThunk(
  "journal/createTradeReview",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { trade_id, setup_type, followed_plan, emotional_state, notes } = formInfo;
      const res = await api.post(`trade/${trade_id}/review`, {
        setup_type,
        followed_plan,
        emotional_state,
        notes,
      });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const editTradeReview = createAsyncThunk(
  "journal/editTradeReview",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { trade_review_id, setup_type, followed_plan, emotional_state, notes } = formInfo;
      const res = await api.put(`review/${trade_review_id}`, {
        setup_type,
        followed_plan,
        emotional_state,
        notes,
      });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const deleteTradeReview = createAsyncThunk(
  "journal/deleteTradeReview",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { trade_review_id } = formInfo;
      const res = await api.delete(`review/${trade_review_id}`);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getUserReviews = createAsyncThunk(
  "journal/getUserReviews",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("user/reviews");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const uploadReviewScreenshot = createAsyncThunk(
  "journal/uploadReviewScreenshot",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { trade_review_id, selectedFile } = formInfo;
      const formData = new FormData();
      formData.append("screenshot", selectedFile);
      const res = await api.post(`review/${trade_review_id}/screenshot`, formData);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);
